import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ContentSkeleton from './components/ContentSkeleton';
import Page from '../../components/Page.js';
import Markdown from '../../components/Markdown';
import Grid from '@material-ui/core/Grid';
import ContentContainer from '../../components/ContentContainer.js';
import Button from '../../components/Button';
import Typography from '@material-ui/core/Typography';
import heroImage from '../../assets/provider-hero.png';
import backgroundImage from '../../assets/bubble-background.svg';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ProviderLoginContainer from '../auth/components/ProviderLoginContainer';
import ProviderStat from './components/ProviderStat';
import BenefitsTable from './components/BenefitsTable';

const useStyles = makeStyles({
  backgroundImage: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  heroImage: {
    marginTop: 0,
    maxWidth: 400,
  },
  statContainer: {
    maxWidth: 400,
  },
  buttonContainer: {
    marginBottom: '2rem',
    marginTop: '2rem',
  },
  buttonLabel: {
    fontSize: '0.85rem',
    maxWidth: 200,
    marginTop: 10,
  },
  loginContainer: {
    maxWidth: 400,
  },
});

const SignUpCTA = ({variant='contained'}) => {
  const classes = useStyles();
  return (
    <div className={classes.buttonContainer}>
      <Button label="Provider Sign Up" className={classes.button} to="/providers/signup" variant={variant}/>
      <Typography variant="body2" className={classes.buttonLabel}>
        Sign up now to create your FREE provider profile.
      </Typography>
    </div>
  );
};
SignUpCTA.propTypes = {
  variant: PropTypes.string,
};

const ProvidersPage = ({content}) => {
  const compactLayout = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const classes = useStyles();


  if (!content) return <ContentSkeleton/>;
  return (
    <Page title={content.title}>
      <div className={classes.backgroundImage}>
        <ContentContainer>
          <Grid container spacing={2}>
            <Grid item md={6} sm={12}>
              <Markdown content={content.body1}/>
              {compactLayout ?
                /* for compact layout we show the login form in-line */
                <Grid item md={12}>
                  <ProviderLoginContainer/>
                </Grid>
                :
                /* for non-compact layout we have the signup CTA duplicated here */
                <Grid item md={6}>
                  <SignUpCTA variant="outlined"/>
                </Grid>
              }
              <div className={classes.statContainer}>
                {content.stats.map((stat, key) => <ProviderStat key={key} {...stat}/>)}
              </div>
              <Markdown content={content.body2}/>
            </Grid>
            {!compactLayout &&
              /* for non-compact layout the right column is added with a login form and a hero image */
              <Grid item container md={6} sm={12} alignContent="center" direction="column">
                <ProviderLoginContainer/>
                <img alt="" src={heroImage} className={classes.heroImage}/>
              </Grid>
            }
            <Grid item md={8} sm={12}>
              <BenefitsTable content={content}/>
              <Markdown content={content.body3}/>
              <SignUpCTA variant="contained"/>
            </Grid>
          </Grid>
        </ContentContainer>
      </div>
    </Page>
  );
};

ProvidersPage.propTypes = {
  content: PropTypes.object,
};

export default ProvidersPage;
